module.exports = __webpack_public_path__ + "3f16e137/img/saly-icon.39e12342.jpg";